import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FallbackIcon = function FallbackIcon(_ref) {
  var size = _ref.size,
    color = _ref.color;
  return ___EmotionJSX("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "4",
    stroke: color || 'black',
    strokeWidth: "1.5"
  }));
};
FallbackIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
};
export default FallbackIcon;